import { render, staticRenderFns } from "./PreRegistration.vue?vue&type=template&id=d2c67e2e&lang=true"
import script from "./PreRegistration.vue?vue&type=script&lang=js"
export * from "./PreRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports